.page { flex: 1; overflow-y: auto; padding-bottom: 40px; background: var(--bg); }

/* Всё содержимое под заголовком — с теми же отступами, что у заголовка */
.page > :not(header) { margin-left: 32px; margin-right: 32px; }

.stale { color: var(--warn); font-weight: 600; }
.spacer { flex: 1; }

.importBox { display: flex; gap: 8px; align-items: center; }
.dateInput { width: 150px; }

.importState {
  display: flex; align-items: center; gap: 12px; margin-bottom: 16px; padding: 10px 14px;
  font-size: 13.5px; color: var(--ok); background: var(--ok-bg); border-radius: var(--r-sm);
}
.importError { color: var(--err); background: var(--err-bg); }
.progress { flex: 1; max-width: 240px; height: 6px; background: rgba(0, 0, 0, .08); border-radius: var(--r-bar); overflow: hidden; }
.progress span { display: block; height: 100%; background: currentColor; transition: width .3s; }

.linkButton {
  margin-left: auto; padding: 4px 8px; font-size: 13px; color: var(--blue);
  background: none; border: none; cursor: pointer;
}
:global(html.dark) .linkButton { color: var(--navy-accent); }

.errorBox { margin-bottom: 16px; padding: 10px 14px; font-size: 13.5px; color: var(--err); background: var(--err-bg); border-radius: var(--r-sm); }

.empty {
  max-width: 640px; padding: 28px; font-size: 14px; line-height: 1.6; color: var(--text2);
  background: var(--card-bg); border: 1px dashed var(--border); border-radius: var(--r-lg);
}
.emptyTitle { margin-bottom: 6px; font-size: 17px; font-weight: 600; color: var(--text); }

/* ── Состояние портов ── */
.overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 20px 40px;
  align-items: center;
  margin-bottom: 20px;
  padding: 22px 26px;
  background: var(--hero-bg);
  border: 1px solid var(--hero-border);
  border-radius: var(--r-lg);
}

.overviewMain { min-width: 0; }

.overviewTotal { display: flex; align-items: baseline; flex-wrap: wrap; gap: 4px 12px; }

.totalValue {
  font-size: 34px; font-weight: 650; line-height: 1; letter-spacing: -.015em;
  color: var(--hero-strong); font-variant-numeric: tabular-nums;
}

.totalLabel { font-size: 14px; color: var(--hero-text); }

.overviewBar {
  display: flex; gap: 2px; height: 10px; margin: 14px 0 12px; overflow: hidden;
  background: var(--hero-track); border-radius: var(--r-bar);
}
.overviewBar > span { display: block; height: 100%; }

.legend { display: flex; flex-wrap: wrap; gap: 4px 6px; margin-left: -8px; }

.legendItem {
  display: inline-flex; align-items: center; gap: 8px; height: 30px; padding: 0 10px;
  font-size: 13.5px; color: var(--hero-text);
  background: none; border: 1px solid transparent; border-radius: var(--r-pill); cursor: pointer;
}
.legendItem:hover { color: var(--hero-strong); background: var(--tile-bg); }
.legendActive, .legendActive:hover { color: var(--hero-strong); background: var(--tile-bg); border-color: var(--blue); }
.legendDot { width: 10px; height: 10px; border-radius: 2px; }
.legendLabel { white-space: nowrap; }
.legendValue { font-weight: 600; color: var(--hero-strong); font-variant-numeric: tabular-nums; }

.facts { display: flex; gap: 32px; margin: 0; }
.facts > div { display: flex; flex-direction: column-reverse; gap: 2px; }
.facts dt { font-size: 12.5px; color: var(--hero-text); }
.facts dd {
  margin: 0; font-size: 22px; font-weight: 650; color: var(--hero-strong);
  font-variant-numeric: tabular-nums;
}

.factButton {
  padding: 0 6px; margin-left: -6px; font: inherit; color: inherit;
  background: none; border: 1px solid transparent; border-radius: var(--r-sm); cursor: pointer;
}
.factButton:hover { background: var(--tile-bg); }
.factWarn { color: var(--warn); }
.factActive, .factActive:hover { background: var(--tile-bg); border-color: var(--blue); }

/* ── Отбор ── */
.filters { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 16px; }

.select, .search {
  height: 36px; padding: 0 10px; font-size: 13.5px; color: var(--text);
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.select { max-width: 210px; }
.search { flex: 1 1 240px; min-width: 200px; }
.select:focus, .search:focus { border-color: var(--blue); outline: none; }

.segment {
  display: inline-flex; height: 36px; padding: 3px;
  background: var(--table-even); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.segButton {
  padding: 0 12px; font-size: 13px; font-weight: 500; color: var(--text2);
  background: none; border: none; border-radius: 4px; cursor: pointer;
}
.segActive { color: var(--text); background: var(--card-bg); box-shadow: 0 1px 2px var(--shadow); }

/* ── Вкладки ── */
.viewSwitch {
  display: flex; flex-wrap: wrap; align-items: center; gap: 4px; margin-bottom: 12px;
  border-bottom: 1px solid var(--border);
}
.viewButton {
  display: inline-flex; align-items: center; gap: 6px;
  height: 40px; padding: 0 14px; margin-bottom: -1px;
  font-size: 14px; font-weight: 500; color: var(--text2); white-space: nowrap;
  background: none; border: none; border-bottom: 2px solid transparent; cursor: pointer;
}
.viewButton:hover { color: var(--text); }
.viewActive, .viewActive:hover { color: var(--text); border-bottom-color: var(--blue); }
.viewSwitch > button:last-child { margin-bottom: 6px; }
.exportError { margin-bottom: 6px; font-size: 13px; color: var(--err); }
.count {
  padding: 0 7px; font-size: 12px; font-weight: 600; line-height: 20px; color: var(--text2);
  background: var(--border); border-radius: var(--r-pill); font-variant-numeric: tabular-nums;
}

/* ── Таблицы ── */
.tableWrap { overflow-x: auto; background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-md); }
.table { width: 100%; border-collapse: collapse; }

.table th {
  position: sticky; top: 0; z-index: 1; padding: 10px 12px; line-height: 18px;
  font-size: 12.5px; font-weight: 600; color: var(--text2); text-align: left; white-space: nowrap;
  background: var(--card-bg); box-shadow: inset 0 -1px 0 var(--border);
}

/* Строка фильтров по столбцам — прилипает под заголовком (его высота 38px) */
.table .filterRow th { top: 38px; padding: 6px 6px 8px; font-weight: 400; }

.colFilter {
  width: 100%; min-width: 64px; height: 30px; padding: 0 8px;
  font-size: 12.5px; font-family: inherit; color: var(--text);
  background: var(--input-bg); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.colFilter::placeholder { color: var(--text2); opacity: .75; }
.colFilter:focus { border-color: var(--blue); outline: none; }
.colFilterOn { border-color: var(--blue); background: var(--card-bg); }
.colFilterBad, .colFilterBad:focus { border-color: var(--err); background: var(--err-bg); }

.table td {
  padding: 10px 12px; font-size: 13.5px; color: var(--text);
  border-bottom: 1px solid var(--border); vertical-align: middle;
}
.table tbody tr:last-child td { border-bottom: none; }

.swRow { cursor: pointer; }
.swRow:hover td { background: var(--table-hover); }
.swOpen td { background: var(--table-even); }
.expandRow > td { padding: 0; background: var(--table-even); }
.chevron { width: 28px; color: var(--text2); text-align: center; }

.none, .note { padding: 20px; font-size: 13.5px; text-align: center; color: var(--text2); }
.note { padding: 0 0 10px; text-align: left; }

.mono { font-family: var(--mono); font-size: 12.5px; }
.sub { margin-top: 2px; font-size: 12px; color: var(--text2); font-family: var(--mono); }
.muted { color: var(--text2); }
.num { font-variant-numeric: tabular-nums; font-weight: 600; }
.warnChip { padding: 2px 8px; font-size: 12px; color: var(--warn); background: var(--warn-bg); border-radius: var(--r-pill); }

/* ── Статусы: одна гамма везде ── */
.stUP { background: var(--ok); color: #fff; }
.stDOWN { background: #C3CAD0; color: #3D4247; }
.stADM { background: #6B7580; color: #F1F3F5; }

.bar { display: flex; gap: 1px; width: 150px; height: 8px; overflow: hidden; background: var(--border); border-radius: var(--r-bar); }
.bar > span { display: block; height: 100%; }

.pill { display: inline-block; padding: 1px 8px; font-size: 11.5px; font-weight: 600; border-radius: var(--r-pill); }

/* Цвет VLAN приходит в переменной — тот же, что на панели портов в карточке */
.vlanChip {
  display: inline-block; padding: 1px 8px; font-size: 12px; font-weight: 600; color: #fff;
  background: var(--vlan, var(--slate)); border-radius: var(--r-pill); font-variant-numeric: tabular-nums;
}

/* Назначение VLAN из справочника — под номером, мелко */
.vlanDesc { margin-top: 2px; font-size: 12px; line-height: 1.3; color: var(--text2); white-space: nowrap; }
.vlanLegend { display: flex; flex-wrap: wrap; gap: 6px 16px; margin-bottom: 12px; font-size: 13px; color: var(--text2); }
.vlanLegend span { display: inline-flex; align-items: center; gap: 6px; }
.vlanLegend i { width: 10px; height: 10px; border-radius: 2px; background: var(--vlan); }
.macs { display: flex; flex-wrap: wrap; gap: 3px; }
.mac {
  padding: 1px 6px; font-family: var(--mono); font-size: 11.5px; color: var(--text);
  background: var(--table-even); border: 1px solid var(--border); border-radius: 4px;
}

/* ── Раскрытый коммутатор ── */
.expand { padding: 16px 18px 18px; }
.expandNote { padding: 16px 18px; font-size: 13.5px; color: var(--text2); }

/* Лицевая панель: корпус светлый в светлой теме, тёмный — в тёмной */
.faceplate {
  overflow-x: auto; padding: 12px 14px; margin-bottom: 12px;
  background: var(--dev-body); border: 1px solid var(--dev-edge); border-radius: var(--r-md);
}

/* Нечётные порты сверху, чётные снизу — как на корпусе */
.faceGrid { display: grid; grid-template-rows: repeat(2, auto); grid-auto-flow: column; gap: 4px; width: max-content; }
.faceTile {
  width: 30px; height: 26px; padding: 0; font-size: 11px; font-weight: 600;
  border: none; border-bottom: 3px solid transparent; border-radius: 3px; cursor: pointer;
}
.faceTile:focus-visible { outline: 2px solid var(--blue); outline-offset: 1px; }
.faceDim { opacity: .25; }
.faceSel { box-shadow: 0 0 0 2px var(--blue); }
:global(html.dark) .faceSel { box-shadow: 0 0 0 2px #fff; }

.portCard {
  margin-bottom: 12px; padding: 12px 14px; font-size: 13.5px; line-height: 1.6;
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-sm);
}
.portDevice { color: var(--text2); }
.miniTable { width: 100%; border-collapse: collapse; }
.miniTable th {
  padding: 7px 10px; font-size: 12.5px; font-weight: 600; text-align: left;
  color: var(--text2); border-bottom: 1px solid var(--border);
}
.miniTable td { padding: 7px 10px; font-size: 13px; border-bottom: 1px solid var(--border); cursor: pointer; }
.rowSel td { background: var(--table-hover); }

@media (max-width: 1023px) {
  .overview { grid-template-columns: 1fr; }
}

@media (max-width: 699px) {
  .page > :not(header) { margin-left: 16px; margin-right: 16px; }
  .overview { padding: 18px 16px; }
  .facts { flex-wrap: wrap; gap: 16px 24px; }
  .hideMobile { display: none; }
  .bar { width: 90px; }
  .select { max-width: none; flex: 1 1 140px; }
  .importBox { width: 100%; }
}
